<template>  
  <md-button :class="dynamicClasses" class="button-filter" :md-ripple="ripple" :disabled="disabled" @click="onClick">
    <div><slot /></div>
    <div class="button-filter__icon" v-show="icon"><md-icon>close</md-icon></div>
  </md-button>  
</template>
<script>
export default {
  name: 'nna-button-filter',
  data () {
    return {
      icon: false
    }
  },
  props: {
    type: {
      type: String,
      default: 'raised',
    },
    color: {
      type: String, 
      default: 'primary',
    },
    ripple: {
      type: Boolean, 
      default: false,          
    }, 
    disabled: {
      type: Boolean, 
      default: false,          
    },
    loading: {
      type: Boolean, 
      default: false,          
    },       
  },
  computed: {
    dynamicClasses () {
      return {
        ['']: this.type === 'flat',
        ['md-raised']: this.type === 'raised',
        ['md-dense']: this.type === 'dense',
        ['md-primary']: this.color === 'primary',
        ['md-accent']: this.color === 'accent',
        ['md-light']: this.color === 'light',
        ['md-light border']: this.color === 'light-2',
      }
    }
  },
  methods: {
    onClick() {
      this.icon = !this.icon
    }
  },
}
</script>

<style scoped>
.button-filter {
  min-width: 90px;
  height: 35px;
  border-radius: 50px;
  position: relative;
  border-radius: 50px;
  width: auto; 
}
.button-filter__icon {
  position: absolute;
  top: 13px;
  right: 5px;
}
</style>


// WEBPACK FOOTER //
// ../nonameapp-common-modules/src/components/ButtonFilter/ButtonFilter.vue